// =============================================================================
// useAuth — Admin auth hook
// =============================================================================

import { useAuthStore } from '@/lib/auth-store';

export function useAuth() {
  const store = useAuthStore();

  return {
    user: store.user,
    status: store.status,
    error: store.error,
    isAuthenticated: store.status === 'authenticated',
    isLoading: store.status === 'idle' || store.status === 'loading',
    isInitialized: store.status !== 'idle',
    login: store.login,
    logout: store.logout,
    initialize: store.initialize,
    setUser: store.setUser,
    clearError: store.clearError,
  };
}
